import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/bierling1709.pdf'; 
import { Helmet } from 'react-helmet';

function Page() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
        Source:<br /><br />
        <var>Die philophischen schriften von Gottfried Wilheim Leibniz, vol. VII</var><br />
		C. I. Gerhardt (ed)<br />
		pp 488-489<br /><br />
        {isMobile ? '' : <hr className="centered-hr" />}
		Date: 24 October 1709<br /><br />
        Translated from the Latin<br /><br /> 
        {isMobile ? '' : <hr className="centered-hr" />}
        <Link to={pdf} target="_blank">View this translation in PDF format (6k)</Link>
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>Leibniz to Friedrich Wilhelm Bierling (24 October 1709)</title>
            <meta name="description" content="An English translation of a LETTER TO FRIEDRICH WILHELM BIERLING by Gottfried Wilhelm Leibniz, from 24 October 1709" />
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <h2 id='top' className={`PageTitle ${isMobile ? 'mobile' : ''}`}>LEIBNIZ TO FRIEDRICH WILHELM BIERLING</h2>
                  {isMobile ? (
                    <>
                    {renderLinks()}  
                    </>
                  ) : (
                    <>
                    
                    </>
                  )}
                 <br />
                 [<b>G VII 488</b>]<br /><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;I agree that logic, if well taught and practically applied, is by no means to be scorned. Indeed, if a more perfect logic were available, nothing more useful could easily befall mortals. In Locke, there are certain particular points that are not badly expounded, but on the whole he has strayed far from the straight and narrow and has not understood the nature of the mind or of truth. Had he sufficiently considered the distinction between necessary truths, that is, those perceived by demonstration, and those which become known to us only by some kind of induction, he would have noticed that necessary truths can be proved only from principles innate to the mind, since the senses indeed teach us what happens, but not what happens necessarily. Likewise, he did not sufficiently observe that the ideas of being, of one and the same substance, of truth, of good, and many other things are innate to our mind because it is innate to itself, and it discovers all these things within itself. For indeed, there is nothing in the intellect which was not in the senses, except the intellect itself. Many other critical observations could be made against Locke, since he even silently undermines the immaterial nature of the soul. He inclined towards the Socinians [<b>G VII 489]</b> (as did his friend Mr. Le Clerc), whose philosophy concerning God and the mind has always been rather poor.<br /><br /><br />
                &#169; Lloyd Strickland 2007. Revised 2025
                <br></br><br></br>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default Page;
